module.exports = __webpack_public_path__ + "media/viral-video.8c244a53.mp4";